/**
 * Extrai o identificador de um vídeo do YouTube.
 *
 * Aceita o identificador solto e as formas de URL que as pessoas realmente
 * colam: `watch?v=`, `youtu.be/`, `/embed/`, `/shorts/` e `/live/`, com ou sem
 * parâmetros pendurados. Exigir os onze caracteres exatos seria tecnicamente
 * defensável e na prática garantiria que alguém colasse a URL inteira e visse
 * "identificador inválido" sem entender o motivo.
 *
 * Devolve `null` quando não reconhece — a tela trata isso como campo inválido,
 * e não como vídeo removido.
 */
const ONZE = /^[A-Za-z0-9_-]{11}$/;

const CAMINHOS = ['/embed/', '/shorts/', '/live/', '/v/'];

export function extrairYoutubeId(entrada: string): string | null {
  const texto = entrada.trim();

  if (texto === '') return null;
  if (ONZE.test(texto)) return texto;

  let url: URL;

  try {
    // Sem esquema, `new URL` recusa; quem cola "youtu.be/abc" não digitou https.
    url = new URL(texto.startsWith('http') ? texto : `https://${texto}`);
  } catch {
    return null;
  }

  const host = url.hostname.replace(/^www\./, '');

  if (host === 'youtu.be') return validar(url.pathname.slice(1));

  if (host !== 'youtube.com' && host !== 'youtube-nocookie.com' && host !== 'm.youtube.com') {
    return null;
  }

  const doParametro = url.searchParams.get('v');

  if (doParametro !== null) return validar(doParametro);

  for (const caminho of CAMINHOS) {
    if (url.pathname.startsWith(caminho)) return validar(url.pathname.slice(caminho.length));
  }

  return null;
}

function validar(candidato: string): string | null {
  const limpo = candidato.split('/')[0] ?? '';

  return ONZE.test(limpo) ? limpo : null;
}
